import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "defaultOffset7": "instant-apply-2815a027-defaultOffset7-WXUgJq",
  "default9": "instant-apply-2815a027-default9-WXUgJq",
  "defaultOffset9": "instant-apply-2815a027-defaultOffset9-WXUgJq",
  "wideOffset5": "instant-apply-2815a027-wideOffset5-WXUgJq",
  "defaultOffset11": "instant-apply-2815a027-defaultOffset11-WXUgJq",
  "wide11": "instant-apply-2815a027-wide11-WXUgJq",
  "tiny6": "instant-apply-2815a027-tiny6-WXUgJq",
  "standardGridContainer": "instant-apply-2815a027-standardGridContainer-WXUgJq",
  "wideOffset4": "instant-apply-2815a027-wideOffset4-WXUgJq",
  "confinedOffset4": "instant-apply-2815a027-confinedOffset4-WXUgJq",
  "xwideOffset3": "instant-apply-2815a027-xwideOffset3-WXUgJq",
  "gridContainer": "instant-apply-2815a027-gridContainer-WXUgJq",
  "defaultOffset3": "instant-apply-2815a027-defaultOffset3-WXUgJq",
  "tinyOffset5": "instant-apply-2815a027-tinyOffset5-WXUgJq",
  "confinedOffset0": "instant-apply-2815a027-confinedOffset0-WXUgJq",
  "wide7": "instant-apply-2815a027-wide7-WXUgJq",
  "col": "instant-apply-2815a027-col-WXUgJq",
  "default4": "instant-apply-2815a027-default4-WXUgJq",
  "xwideOffset9": "instant-apply-2815a027-xwideOffset9-WXUgJq",
  "confined9": "instant-apply-2815a027-confined9-WXUgJq",
  "wide9": "instant-apply-2815a027-wide9-WXUgJq",
  "tinyOffset11": "instant-apply-2815a027-tinyOffset11-WXUgJq",
  "confined12": "instant-apply-2815a027-confined12-WXUgJq",
  "wide1": "instant-apply-2815a027-wide1-WXUgJq",
  "default7": "instant-apply-2815a027-default7-WXUgJq",
  "wideOffset8": "instant-apply-2815a027-wideOffset8-WXUgJq",
  "wide5": "instant-apply-2815a027-wide5-WXUgJq",
  "tinyOffset10": "instant-apply-2815a027-tinyOffset10-WXUgJq",
  "wideOffset7": "instant-apply-2815a027-wideOffset7-WXUgJq",
  "confinedOffset8": "instant-apply-2815a027-confinedOffset8-WXUgJq",
  "tiny8": "instant-apply-2815a027-tiny8-WXUgJq",
  "defaultOffset4": "instant-apply-2815a027-defaultOffset4-WXUgJq",
  "tinyOffset6": "instant-apply-2815a027-tinyOffset6-WXUgJq",
  "tinyOffset1": "instant-apply-2815a027-tinyOffset1-WXUgJq",
  "wideGridContainer": "instant-apply-2815a027-wideGridContainer-WXUgJq",
  "confinedOffset9": "instant-apply-2815a027-confinedOffset9-WXUgJq",
  "xwide12": "instant-apply-2815a027-xwide12-WXUgJq",
  "xwideOffset7": "instant-apply-2815a027-xwideOffset7-WXUgJq",
  "xwide6": "instant-apply-2815a027-xwide6-WXUgJq",
  "xwide8": "instant-apply-2815a027-xwide8-WXUgJq",
  "confined10": "instant-apply-2815a027-confined10-WXUgJq",
  "default8": "instant-apply-2815a027-default8-WXUgJq",
  "defaultOffset5": "instant-apply-2815a027-defaultOffset5-WXUgJq",
  "xwideOffset0": "instant-apply-2815a027-xwideOffset0-WXUgJq",
  "wide12": "instant-apply-2815a027-wide12-WXUgJq",
  "xwideOffset1": "instant-apply-2815a027-xwideOffset1-WXUgJq",
  "default10": "instant-apply-2815a027-default10-WXUgJq",
  "default5": "instant-apply-2815a027-default5-WXUgJq",
  "tinyOffset0": "instant-apply-2815a027-tinyOffset0-WXUgJq",
  "confined6": "instant-apply-2815a027-confined6-WXUgJq",
  "xwideOffset2": "instant-apply-2815a027-xwideOffset2-WXUgJq",
  "default1": "instant-apply-2815a027-default1-WXUgJq",
  "tinyOffset4": "instant-apply-2815a027-tinyOffset4-WXUgJq",
  "wide4": "instant-apply-2815a027-wide4-WXUgJq",
  "tinyOffset7": "instant-apply-2815a027-tinyOffset7-WXUgJq",
  "wideOffset10": "instant-apply-2815a027-wideOffset10-WXUgJq",
  "xwide0": "instant-apply-2815a027-xwide0-WXUgJq",
  "xwide4": "instant-apply-2815a027-xwide4-WXUgJq",
  "tiny7": "instant-apply-2815a027-tiny7-WXUgJq",
  "tiny5": "instant-apply-2815a027-tiny5-WXUgJq",
  "wide2": "instant-apply-2815a027-wide2-WXUgJq",
  "wideOffset3": "instant-apply-2815a027-wideOffset3-WXUgJq",
  "wideOffset6": "instant-apply-2815a027-wideOffset6-WXUgJq",
  "wideOffset2": "instant-apply-2815a027-wideOffset2-WXUgJq",
  "xwideOffset8": "instant-apply-2815a027-xwideOffset8-WXUgJq",
  "defaultOffset2": "instant-apply-2815a027-defaultOffset2-WXUgJq",
  "wideOffset9": "instant-apply-2815a027-wideOffset9-WXUgJq",
  "confinedOffset5": "instant-apply-2815a027-confinedOffset5-WXUgJq",
  "xwide3": "instant-apply-2815a027-xwide3-WXUgJq",
  "tiny12": "instant-apply-2815a027-tiny12-WXUgJq",
  "xwideOffset5": "instant-apply-2815a027-xwideOffset5-WXUgJq",
  "grid": "instant-apply-2815a027-grid-WXUgJq",
  "default0": "instant-apply-2815a027-default0-WXUgJq",
  "confinedOffset11": "instant-apply-2815a027-confinedOffset11-WXUgJq",
  "wide10": "instant-apply-2815a027-wide10-WXUgJq",
  "confinedOffset7": "instant-apply-2815a027-confinedOffset7-WXUgJq",
  "default2": "instant-apply-2815a027-default2-WXUgJq",
  "defaultOffset8": "instant-apply-2815a027-defaultOffset8-WXUgJq",
  "tinyOffset2": "instant-apply-2815a027-tinyOffset2-WXUgJq",
  "default3": "instant-apply-2815a027-default3-WXUgJq",
  "confined1": "instant-apply-2815a027-confined1-WXUgJq",
  "confinedOffset10": "instant-apply-2815a027-confinedOffset10-WXUgJq",
  "xwide5": "instant-apply-2815a027-xwide5-WXUgJq",
  "xwide1": "instant-apply-2815a027-xwide1-WXUgJq",
  "tiny9": "instant-apply-2815a027-tiny9-WXUgJq",
  "default12": "instant-apply-2815a027-default12-WXUgJq",
  "confinedOffset2": "instant-apply-2815a027-confinedOffset2-WXUgJq",
  "default11": "instant-apply-2815a027-default11-WXUgJq",
  "wide3": "instant-apply-2815a027-wide3-WXUgJq",
  "xwide2": "instant-apply-2815a027-xwide2-WXUgJq",
  "wide0": "instant-apply-2815a027-wide0-WXUgJq",
  "tinyOffset9": "instant-apply-2815a027-tinyOffset9-WXUgJq",
  "wideOffset0": "instant-apply-2815a027-wideOffset0-WXUgJq",
  "xwide9": "instant-apply-2815a027-xwide9-WXUgJq",
  "defaultOffset6": "instant-apply-2815a027-defaultOffset6-WXUgJq",
  "confinedOffset3": "instant-apply-2815a027-confinedOffset3-WXUgJq",
  "xwideOffset10": "instant-apply-2815a027-xwideOffset10-WXUgJq",
  "tiny3": "instant-apply-2815a027-tiny3-WXUgJq",
  "xwide11": "instant-apply-2815a027-xwide11-WXUgJq",
  "default6": "instant-apply-2815a027-default6-WXUgJq",
  "row": "instant-apply-2815a027-row-WXUgJq",
  "confined2": "instant-apply-2815a027-confined2-WXUgJq",
  "confined3": "instant-apply-2815a027-confined3-WXUgJq",
  "xwideOffset11": "instant-apply-2815a027-xwideOffset11-WXUgJq",
  "tiny2": "instant-apply-2815a027-tiny2-WXUgJq",
  "armstrongGridContainer": "instant-apply-2815a027-armstrongGridContainer-WXUgJq",
  "confinedOffset1": "instant-apply-2815a027-confinedOffset1-WXUgJq",
  "confined11": "instant-apply-2815a027-confined11-WXUgJq",
  "xwide7": "instant-apply-2815a027-xwide7-WXUgJq",
  "xwideOffset4": "instant-apply-2815a027-xwideOffset4-WXUgJq",
  "tiny0": "instant-apply-2815a027-tiny0-WXUgJq",
  "tiny4": "instant-apply-2815a027-tiny4-WXUgJq",
  "wideOffset1": "instant-apply-2815a027-wideOffset1-WXUgJq",
  "tiny1": "instant-apply-2815a027-tiny1-WXUgJq",
  "wideOffset11": "instant-apply-2815a027-wideOffset11-WXUgJq",
  "xwide10": "instant-apply-2815a027-xwide10-WXUgJq",
  "defaultOffset10": "instant-apply-2815a027-defaultOffset10-WXUgJq",
  "tinyOffset8": "instant-apply-2815a027-tinyOffset8-WXUgJq",
  "wide8": "instant-apply-2815a027-wide8-WXUgJq",
  "tiny11": "instant-apply-2815a027-tiny11-WXUgJq",
  "confined4": "instant-apply-2815a027-confined4-WXUgJq",
  "xwideOffset6": "instant-apply-2815a027-xwideOffset6-WXUgJq",
  "confined5": "instant-apply-2815a027-confined5-WXUgJq",
  "wide6": "instant-apply-2815a027-wide6-WXUgJq",
  "confined0": "instant-apply-2815a027-confined0-WXUgJq",
  "defaultOffset1": "instant-apply-2815a027-defaultOffset1-WXUgJq",
  "tiny10": "instant-apply-2815a027-tiny10-WXUgJq",
  "tinyOffset3": "instant-apply-2815a027-tinyOffset3-WXUgJq",
  "confined7": "instant-apply-2815a027-confined7-WXUgJq",
  "confined8": "instant-apply-2815a027-confined8-WXUgJq",
  "confinedOffset6": "instant-apply-2815a027-confinedOffset6-WXUgJq"
};